import { Event } from './event';

export enum ActivityDepartment {
  AUSSENDIENST = 'AD',
  CUSTOMERSERVICE = 'CS',
  CASEMANAGEMENT = 'CM',
}

export enum ActivityStatus {
  OFFEN = 'OFFEN',
  FERTIG = 'FERTIG',
  ABGELEHNT = 'ABGELEHNT',
}

export enum ActivityType {
  MEHRBEDARF_BEANTRAGEN = 'MEHRBEDARF_BEANTRAGEN',
  PFLICHTDOKUMENTE_ERSTELLUNG = 'PFLICHTDOKUMENTE_ERSTELLUNG',
  PFLICHTDOKUMENTE_UEBERMITTLUNG = 'PFLICHTDOKUMENTE_ÜBERMITTLUNG',
  PFLICHTDOKUMENTE_KORREKTUR = 'PFLICHTDOKUMENTE_KORREKTUR',
  UEBERGABE_CS_ANFRAGE = 'UEBERGABE_CS_ANFRAGE',
  UEBERGABE_CS_BENACHRICHTIGUNG = 'UEBERGABE_CS_BENACHRICHTIG',
  UEBERGABE_ABGELEHNT = 'UEBERGABE_ABGELEHNT',
  GESPRAECH_VORBEREITEN = 'GESPRAECH_VORBEREITEN',
  CHECKINCALL_DURCHFUEHREN = 'CHECKINCALL_DURCHFUEHREN',
  CHECKINCALL_DOKU_ABGELEGT = 'CHECKINCALL_DOKU_ABGELEGT',
  CHECKINCALL_ABGESCHLOSSEN = 'CHECKINCALL_ABGESCHLOSSEN',
}

export interface Document {
  documentId: string;
  templateId: string;
}

export interface TaskActivity extends Event {
  info: string;
  id: string;
  taskId: string;
  patientId: string | null;
  fieldNurseId: string | null; // entspricht userId des verantwortlichen AD,
  department: ActivityDepartment;
  status: ActivityStatus;
  type: ActivityType;
  message: string; // (max. 250 char)
  documents: Document[];
}

// WARTET AUF ABGELEHNT STATUS AUSBAU
// export interface ActivityCreateDto {
//   eventType: EventType;
//   taskId: string;
//   patientId: string | null;
//   fieldNurseId: string | null;
//   department: ActivityDepartment;
//   status: ActivityStatus;
//   type: ActivityType;
//   message: string;
// }
